module.exports = __webpack_public_path__ + "img/625.Dirty_floor.2ca3c85c.svg";